// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2364748B%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m6 9 6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * RobiTest shared modal theme — modern white-header surface
 * Matches Edit Project / Create Test Execution (RT2).
 * Loaded via theme so it applies app-wide to [data-rt-modal-overlay] dialogs.
 */

/* ── Overlay ─────────────────────────────────────────────────────── */
[data-rt-modal-overlay].modal-overlay,
[data-rt-modal-overlay].workspace-modal-overlay,
[data-rt-modal-overlay].test-execution-modal-overlay,
[data-rt-modal-overlay].create-test-suite-modal-overlay,
[data-rt-modal-overlay].edit-test-suite-modal-overlay,
[data-rt-modal-overlay].create-test-case-modal-overlay,
[data-rt-modal-overlay].create-test-case-options-modal-overlay,
[data-rt-modal-overlay].extension-recording-modal-overlay,
[data-rt-modal-overlay].link-test-cases-modal-overlay,
[data-rt-modal-overlay].view-test-case-modal-overlay,
[data-rt-modal-overlay].schedule-modal-overlay,
[data-rt-modal-overlay].rt-edit-project-overlay,
[data-rt-modal-overlay].sprint-modal-overlay,
.workspace-modal-overlay,
.test-execution-modal-overlay,
.sprint-modal-overlay,
.rt-dialog-overlay {
  background: var(--modal-backdrop, rgba(15, 23, 42, 0.52)) !important;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

/* ── Panel shell ─────────────────────────────────────────────────── */
[data-rt-modal-overlay] .modal,
[data-rt-modal-overlay] .modal-container,
[data-rt-modal-overlay] .modal-content:not(.modal-body),
.workspace-modal,
.test-execution-modal,
.create-test-suite-modal,
.edit-test-suite-modal,
.create-test-case-modal-panel,
.create-test-case-options-modal-panel,
.extension-recording-modal-panel,
.link-test-cases-modal-panel,
.view-test-case-modal-panel,
.rt-edit-project-modal,
.rt-modal {
  background: var(--modal-background, var(--surface, #fff)) !important;
  color: var(--text-primary, #0f172a);
  border: 1px solid var(--border, #e2e8f0) !important;
  border-radius: 16px !important;
  box-shadow: var(--modal-shadow, 0 24px 48px rgba(15, 23, 42, 0.2)) !important;
  overflow: hidden;
}

/* ── Header: highlighted primary wash (clearly not plain white) ─── */
[data-rt-modal-overlay] .modal-header,
.workspace-modal .modal-header,
.test-execution-modal .modal-header,
.create-test-suite-modal .modal-header,
.edit-test-suite-modal .modal-header,
.create-test-case-modal-panel .modal-header,
.create-test-case-options-modal-header,
.compile-scripts-modal-header,
.rt-modal__header,
.mfa-modal .modal-header,
.sprint-modal .modal-header,
.sprint-modal__header,
.schedule-modal .modal-header,
.link-test-suites-modal .modal-header {
  background:
    linear-gradient(
      135deg,
      rgba(37, 99, 235, 0.14) 0%,
      rgba(59, 130, 246, 0.1) 48%,
      rgba(96, 165, 250, 0.08) 100%
    ) !important;
  background-color: #eff6ff !important;
  background-image:
    linear-gradient(
      135deg,
      rgba(37, 99, 235, 0.14) 0%,
      rgba(59, 130, 246, 0.1) 48%,
      rgba(96, 165, 250, 0.08) 100%
    ) !important;
  color: var(--text-primary, #0f172a) !important;
  border-bottom: 1px solid rgba(37, 99, 235, 0.22) !important;
  border-radius: 16px 16px 0 0 !important;
  padding: 18px 20px !important;
  align-items: flex-start !important;
  position: relative;
  box-shadow: inset 0 -1px 0 rgba(37, 99, 235, 0.06);
}

[data-rt-modal-overlay] .modal-header::before,
.workspace-modal .modal-header::before,
.test-execution-modal .modal-header::before,
.create-test-suite-modal .modal-header::before,
.edit-test-suite-modal .modal-header::before,
.create-test-case-modal-panel .modal-header::before,
.rt-modal__header::before,
.sprint-modal .modal-header::before,
.sprint-modal__header::before,
.schedule-modal .modal-header::before,
.link-test-suites-modal .modal-header::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--primary, #2563eb), #60a5fa 55%, #93c5fd);
  border-radius: 16px 16px 0 0;
  pointer-events: none;
}

[data-rt-modal-overlay] .modal-header h2,
[data-rt-modal-overlay] .modal-header h3,
[data-rt-modal-overlay] .modal-header .modal-title,
.workspace-modal .modal-header h2,
.test-execution-modal .modal-header h2,
.create-test-case-modal-panel .modal-header h2,
.create-test-case-options-modal-header h2,
.rt-modal__header h2,
.rt-modal__title,
.mfa-modal .modal-header h2 {
  color: #1e3a8a !important;
  font-size: 1.125rem !important;
  font-weight: 700 !important;
  letter-spacing: -0.01em;
  margin: 0 !important;
}

[data-rt-modal-overlay] .modal-header p,
.workspace-modal .modal-header p,
.create-test-case-options-modal-header p,
.rt-modal__header p,
.rt-modal__subtitle,
.project-select-subtitle {
  margin: 4px 0 0 !important;
  font-size: 0.8125rem !important;
  font-weight: 400 !important;
  color: #3b82f6 !important;
  opacity: 0.9 !important;
}

.workspace-modal.project-select-modal .project-select-subtitle strong {
  color: #1e3a8a !important;
  font-weight: 600;
}

/* Close controls on tinted header */
[data-rt-modal-overlay] .modal-header .modal-close,
[data-rt-modal-overlay] .modal-header .modal-close-btn,
[data-rt-modal-overlay] .modal-header .close-button,
[data-rt-modal-overlay] .modal-header .close-btn,
.workspace-modal .modal-close-btn,
.rt-modal__close {
  color: #3b82f6 !important;
  background: rgba(255, 255, 255, 0.55) !important;
  border: 1px solid rgba(37, 99, 235, 0.18);
  border-radius: 8px;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

[data-rt-modal-overlay] .modal-header .modal-close:hover,
[data-rt-modal-overlay] .modal-header .modal-close-btn:hover,
[data-rt-modal-overlay] .modal-header .close-button:hover,
[data-rt-modal-overlay] .modal-header .close-btn:hover,
.workspace-modal .modal-close-btn:hover:not(:disabled),
.rt-modal__close:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.9) !important;
  color: #1d4ed8 !important;
  border-color: rgba(37, 99, 235, 0.35);
  opacity: 1;
}

/* Tailwind blue-gradient headers → same highlighted wash */
[data-rt-modal-overlay] .bg-gradient-to-r.from-blue-500,
[data-rt-modal-overlay] .bg-gradient-to-r.from-blue-600,
[data-rt-modal-overlay] .from-blue-500.to-blue-600,
[data-rt-modal-overlay] .from-blue-600.to-blue-700,
[data-rt-modal-overlay] .from-blue-500.to-indigo-600,
[data-rt-modal-overlay] .from-blue-600.to-indigo-700,
[data-rt-modal-overlay] .from-blue-600.to-blue-500 {
  background-color: #eff6ff !important;
  background-image:
    linear-gradient(
      135deg,
      rgba(37, 99, 235, 0.14) 0%,
      rgba(59, 130, 246, 0.1) 48%,
      rgba(96, 165, 250, 0.08) 100%
    ) !important;
  color: #1e3a8a !important;
  border-bottom: 1px solid rgba(37, 99, 235, 0.22);
}

[data-rt-modal-overlay] .bg-gradient-to-r.from-blue-500 h2,
[data-rt-modal-overlay] .bg-gradient-to-r.from-blue-600 h2,
[data-rt-modal-overlay] .from-blue-500.to-blue-600 h2,
[data-rt-modal-overlay] .from-blue-600.to-blue-700 h2,
[data-rt-modal-overlay] .from-blue-500.to-indigo-600 h2,
[data-rt-modal-overlay] .bg-gradient-to-r .text-white,
[data-rt-modal-overlay] .bg-gradient-to-r h2.text-white,
[data-rt-modal-overlay] .bg-gradient-to-r .text-xl,
[data-rt-modal-overlay] .bg-gradient-to-r .text-lg {
  color: #1e3a8a !important;
}

[data-rt-modal-overlay] .bg-gradient-to-r p,
[data-rt-modal-overlay] .bg-gradient-to-r .text-blue-100,
[data-rt-modal-overlay] .bg-gradient-to-r .opacity-80,
[data-rt-modal-overlay] .bg-gradient-to-r .text-xs {
  color: #3b82f6 !important;
  opacity: 0.9 !important;
}

[data-rt-modal-overlay] .bg-gradient-to-r button,
[data-rt-modal-overlay] .bg-gradient-to-r .hover\\:bg-white\\/20 {
  color: #3b82f6 !important;
}

[data-rt-modal-overlay] .bg-gradient-to-r button:hover {
  background: rgba(255, 255, 255, 0.9) !important;
  color: #1d4ed8 !important;
}

[data-theme='dark'] [data-rt-modal-overlay] .modal-header,
[data-theme='dark'] .workspace-modal .modal-header,
[data-theme='dark'] .test-execution-modal .modal-header,
[data-theme='dark'] .rt-modal__header,
[data-theme='dark'] .create-test-case-modal-panel .modal-header,
[data-theme='dark'] .create-test-case-options-modal-header,
[data-theme='dark'] .compile-scripts-modal-header,
[data-theme='dark'] .mfa-modal .modal-header,
[data-theme='dark'] .sprint-modal .modal-header,
[data-theme='dark'] .schedule-modal .modal-header {
  background-color: rgba(37, 99, 235, 0.18) !important;
  background-image:
    linear-gradient(
      135deg,
      rgba(59, 130, 246, 0.22) 0%,
      rgba(37, 99, 235, 0.12) 100%
    ) !important;
  border-bottom-color: rgba(96, 165, 250, 0.28) !important;
}

[data-theme='dark'] [data-rt-modal-overlay] .modal-header h2,
[data-theme='dark'] .rt-modal__header h2,
[data-theme='dark'] .rt-modal__title,
[data-theme='dark'] .workspace-modal .modal-header h2 {
  color: #bfdbfe !important;
}

[data-theme='dark'] [data-rt-modal-overlay] .modal-header p,
[data-theme='dark'] .rt-modal__header p,
[data-theme='dark'] .rt-modal__subtitle {
  color: #93c5fd !important;
}

[data-theme='dark'] .rt-modal__close,
[data-theme='dark'] [data-rt-modal-overlay] .modal-header .modal-close,
[data-theme='dark'] [data-rt-modal-overlay] .modal-header .close-btn {
  color: #93c5fd !important;
  background: rgba(15, 23, 42, 0.35) !important;
  border-color: rgba(147, 197, 253, 0.25);
}

/* ── Body ────────────────────────────────────────────────────────── */
[data-rt-modal-overlay] .modal-body,
[data-rt-modal-overlay] .modal-content,
.workspace-modal .modal-body,
.test-execution-modal .modal-content,
.rt-modal__body {
  background: transparent !important;
  color: var(--text-primary);
  padding: 20px !important;
}

/* ── Footer ──────────────────────────────────────────────────────── */
[data-rt-modal-overlay] .modal-footer,
[data-rt-modal-overlay] .modal-actions,
.workspace-modal .modal-footer,
.test-execution-modal .modal-footer,
.create-test-case-modal-panel .modal-footer,
.compile-scripts-modal-footer,
.rt-modal__footer {
  background: var(--bg-secondary, var(--surface, #fff)) !important;
  border-top: 1px solid var(--border, #e2e8f0) !important;
  padding: 14px 20px !important;
  gap: 10px !important;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

/* ── Form fields inside modals ───────────────────────────────────── */
[data-rt-modal-overlay] .form-group label,
[data-rt-modal-overlay] label.form-label,
.workspace-modal .form-group label,
.test-execution-modal .form-group > label {
  display: block;
  margin-bottom: 6px;
  font-size: 0.8125rem;
  font-weight: 550;
  color: var(--text-secondary, #475569);
}

[data-rt-modal-overlay] input:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='file']):not([type='hidden']),
[data-rt-modal-overlay] textarea,
[data-rt-modal-overlay] select:not([multiple]),
[data-rt-modal-overlay] .form-input,
[data-rt-modal-overlay] .form-control,
.workspace-modal .form-input,
.test-execution-modal input,
.test-execution-modal textarea,
.test-execution-modal select {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border: 1px solid var(--input-border, #e2e8f0) !important;
  border-radius: 10px !important;
  background: var(--input-background, var(--surface, #fff)) !important;
  color: var(--text-primary, #0f172a) !important;
  font-family: inherit;
  font-size: 0.875rem;
  line-height: 1.4;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-shadow: none;
}

[data-rt-modal-overlay] input:not([type='checkbox']):not([type='radio']):focus,
[data-rt-modal-overlay] textarea:focus,
[data-rt-modal-overlay] select:focus,
[data-rt-modal-overlay] .form-input:focus,
[data-rt-modal-overlay] .form-control:focus,
.workspace-modal .form-input:focus {
  outline: none !important;
  border-color: var(--primary, #2563eb) !important;
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(37, 99, 235, 0.2)) !important;
}

[data-rt-modal-overlay] input::placeholder,
[data-rt-modal-overlay] textarea::placeholder {
  color: var(--input-placeholder, #94a3b8) !important;
  opacity: 1;
}

/* Native select chevron */
[data-rt-modal-overlay] select:not([multiple]) {
  appearance: none;
  padding-right: 36px !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-repeat: no-repeat !important;
  background-position: right 12px center !important;
  background-size: 16px !important;
  cursor: pointer;
}

/* Checkboxes & radios */
[data-rt-modal-overlay] input[type='checkbox'],
[data-rt-modal-overlay] input[type='radio'] {
  width: 1.05rem !important;
  height: 1.05rem !important;
  min-width: 1.05rem;
  margin: 0;
  accent-color: var(--primary, #2563eb);
  cursor: pointer;
  flex-shrink: 0;
  vertical-align: middle;
}

[data-rt-modal-overlay] .checkbox-label,
[data-rt-modal-overlay] label:has(> input[type='checkbox']),
[data-rt-modal-overlay] label:has(> input[type='radio']) {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  font-size: 0.875rem;
  color: var(--text-primary);
}

/*
 * AccessibleSelect / rt-select visuals for modals only.
 * Do NOT set global .rt-select { width: 100% } — that breaks FilterBar
 * toolbars (Test Cases, Projects, etc.) into stacked full-width rows.
 * Canonical select layout lives in components/ui/ui.css.
 */
[data-rt-modal-overlay] .rt-select--form,
[data-rt-modal-overlay] .rt-select:not(.rt-select--filter):not(.rt-select--sm) {
  width: 100%;
}

[data-rt-modal-overlay] .rt-select__trigger {
  border-radius: 10px;
}

[data-rt-modal-overlay] .rt-select__menu {
  border-radius: 12px;
  z-index: 20000;
}

/* ── Primary / secondary buttons in modals ───────────────────────── */
[data-rt-modal-overlay] .modal-action-btn,
[data-rt-modal-overlay] .btn-primary,
.workspace-modal .btn-primary,
.test-execution-modal .btn-primary {
  background: var(--primary, #2563eb) !important;
  border: 1px solid transparent !important;
  color: #fff !important;
  border-radius: 10px !important;
  font-weight: 600;
  padding: 0.55rem 1.1rem;
  box-shadow: none !important;
  background-image: none !important;
}

[data-rt-modal-overlay] .modal-action-btn:hover:not(:disabled),
[data-rt-modal-overlay] .btn-primary:hover:not(:disabled),
.workspace-modal .btn-primary:hover:not(:disabled) {
  background: var(--primary-hover, #1d4ed8) !important;
  transform: none !important;
}

[data-rt-modal-overlay] .modal-cancel-btn,
[data-rt-modal-overlay] .btn-secondary,
[data-rt-modal-overlay] .btn-outline,
.workspace-modal .btn-outline {
  background: var(--surface, #fff) !important;
  border: 1px solid var(--border-strong, #cbd5e1) !important;
  color: var(--text-primary, #0f172a) !important;
  border-radius: 10px !important;
  font-weight: 550;
  padding: 0.55rem 1.1rem;
  background-image: none !important;
  box-shadow: none !important;
}

[data-rt-modal-overlay] .modal-cancel-btn:hover:not(:disabled),
[data-rt-modal-overlay] .btn-secondary:hover:not(:disabled),
[data-rt-modal-overlay] .btn-outline:hover:not(:disabled),
.workspace-modal .btn-outline:hover:not(:disabled) {
  background: var(--surface-hover, #f8fafc) !important;
}

/* ── Shared RtModal shell ────────────────────────────────────────── */
.rt-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 12000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(12px, env(safe-area-inset-top, 0px)) 16px max(12px, env(safe-area-inset-bottom, 0px));
  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55));
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  animation: rt-modal-overlay-in var(--duration-normal, 200ms) ease;
}

.rt-modal {
  width: min(520px, calc(100vw - 32px));
  max-height: min(88vh, 720px);
  max-height: min(88dvh, 720px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--modal-background, var(--surface, #fff));
  color: var(--text-primary, #0f172a);
  border: 1px solid var(--border, #e2e8f0);
  border-radius: var(--radius-2xl, 16px);
  box-shadow: var(--modal-shadow, 0 24px 48px rgba(15, 23, 42, 0.2));
  animation: rt-modal-panel-in var(--duration-slow, 320ms) var(--ease-out, ease);
}

.rt-modal--sm {
  width: min(420px, calc(100vw - 32px));
  max-height: min(80vh, 560px);
  max-height: min(80dvh, 560px);
}

.rt-modal--md {
  width: min(520px, calc(100vw - 32px));
}

.rt-modal--lg {
  width: min(720px, calc(100vw - 32px));
  max-height: min(90vh, 820px);
  max-height: min(90dvh, 820px);
}

.rt-modal--xl {
  width: min(960px, calc(100vw - 32px));
  max-height: min(92vh, 900px);
  max-height: min(92dvh, 900px);
}

.rt-modal--confirm,
.rt-modal--destructive {
  width: min(440px, calc(100vw - 32px));
}

.rt-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px 16px;
  border-bottom: 1px solid rgba(37, 99, 235, 0.22);
  flex-shrink: 0;
  background-color: #eff6ff;
  background-image:
    linear-gradient(
      135deg,
      rgba(37, 99, 235, 0.14) 0%,
      rgba(59, 130, 246, 0.1) 48%,
      rgba(96, 165, 250, 0.08) 100%
    );
}

.rt-modal__header-text {
  min-width: 0;
  flex: 1 1;
}

.rt-modal__title,
.rt-modal__header h2 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: -0.015em;
  line-height: 1.3;
  color: #1e3a8a;
}

.rt-modal__subtitle,
.rt-modal__header p {
  margin: 4px 0 0;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: #3b82f6;
}

.rt-modal__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border: 1px solid rgba(37, 99, 235, 0.18);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.55);
  color: #3b82f6;
  cursor: pointer;
  transition: background var(--duration-fast, 120ms) ease, color var(--duration-fast, 120ms) ease,
    border-color var(--duration-fast, 120ms) ease;
}

.rt-modal__close:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.95);
  color: #1d4ed8;
  border-color: rgba(37, 99, 235, 0.35);
}

.rt-modal__close:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(37, 99, 235, 0.2));
}

.rt-modal__close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.rt-modal__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  scrollbar-gutter: stable;
  -webkit-overflow-scrolling: touch;
}

.rt-modal--confirm .rt-modal__body,
.rt-modal--destructive .rt-modal__body {
  padding-top: 8px;
  padding-bottom: 8px;
}

.rt-modal__section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rt-modal__section + .rt-modal__section {
  margin-top: 4px;
  padding-top: 16px;
  border-top: 1px solid var(--border-subtle, var(--border));
}

.rt-modal__section-title {
  margin: 0 0 2px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.rt-modal__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 0;
}

.rt-modal__label,
.rt-modal__field > span,
.rt-modal__field > label {
  font-size: 0.8125rem;
  font-weight: 550;
  color: var(--text-secondary);
}

.rt-modal__req {
  color: var(--danger, #ef4444);
  font-weight: 600;
}

.rt-modal__field input,
.rt-modal__field textarea,
.rt-modal__field select,
.rt-modal__body input:not([type='checkbox']):not([type='radio']):not([type='file']):not([type='hidden']),
.rt-modal__body textarea,
.rt-modal__body select:not([multiple]) {
  width: 100%;
  box-sizing: border-box;
  min-height: var(--control-height, 36px);
  padding: 8px 12px;
  border: 1px solid var(--input-border, var(--border));
  border-radius: 10px;
  background: var(--input-background, var(--surface));
  color: var(--text-primary);
  font-family: inherit;
  font-size: 0.875rem;
  line-height: 1.4;
  box-shadow: none;
  outline: none;
  transition: border-color var(--duration-fast, 120ms) ease, box-shadow var(--duration-fast, 120ms) ease;
}

.rt-modal__field textarea,
.rt-modal__body textarea {
  min-height: 88px;
  resize: vertical;
}

.rt-modal__field input:hover:not(:disabled),
.rt-modal__field textarea:hover:not(:disabled),
.rt-modal__body input:hover:not(:disabled):not([type='checkbox']):not([type='radio']),
.rt-modal__body textarea:hover:not(:disabled) {
  border-color: var(--border-strong, #cbd5e1);
}

.rt-modal__field input:focus,
.rt-modal__field textarea:focus,
.rt-modal__field select:focus,
.rt-modal__body input:focus,
.rt-modal__body textarea:focus,
.rt-modal__body select:focus {
  border-color: var(--primary, #2563eb);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(37, 99, 235, 0.2));
}

.rt-modal__field input.error,
.rt-modal__field textarea.error,
.rt-modal__body input.error,
.rt-modal__body textarea.error,
.rt-modal__body select.error {
  border-color: var(--danger, #ef4444);
}

.rt-modal__field input:disabled,
.rt-modal__field textarea:disabled,
.rt-modal__body input:disabled,
.rt-modal__body textarea:disabled {
  background: var(--surface-disabled, #f1f5f9);
  color: var(--text-muted);
  cursor: not-allowed;
}

.rt-modal__grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.rt-modal__grid-3 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.rt-modal-meta {
  margin-top: 4px;
  padding-top: 12px;
  border-top: 1px solid var(--border-subtle, var(--border));
  font-size: 0.8125rem;
  color: var(--text-secondary);
}

.rt-modal-meta p {
  margin: 0 0 4px;
}

.rt-modal-meta p:last-child {
  margin-bottom: 0;
}

@media (max-width: 640px) {
  .rt-modal__grid-3 {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 560px) {
  .rt-modal__grid-2 {
    grid-template-columns: 1fr;
  }

  .rt-modal-overlay {
    padding: 8px;
    align-items: flex-end;
  }

  .rt-modal,
  .rt-modal--sm,
  .rt-modal--md,
  .rt-modal--lg,
  .rt-modal--xl {
    width: 100%;
    max-height: min(92vh, 100%);
    max-height: min(92dvh, 100%);
    border-radius: 16px 16px 0 0;
  }
}

.rt-modal__hint {
  margin: 0;
  font-size: 0.75rem;
  color: var(--text-muted);
}

.rt-modal__error,
.rt-modal__body .error-message {
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--danger, #ef4444);
}

.rt-modal__footer,
.rt-modal__actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid var(--border-subtle, var(--border));
  background: transparent;
  flex-shrink: 0;
}

.rt-modal__footer .rt-btn,
.rt-modal__actions .rt-btn,
.rt-modal__footer .btn,
.rt-modal__actions .btn {
  min-height: var(--control-height, 36px);
  border-radius: 10px;
  font-weight: 600;
  padding: 0 14px;
}

@keyframes rt-modal-overlay-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes rt-modal-panel-in {
  from { opacity: 0; transform: translateY(8px) scale(0.985); }
  to { opacity: 1; transform: none; }
}

@media (prefers-reduced-motion: reduce) {
  .rt-modal-overlay,
  .rt-modal {
    animation: none !important;
  }
}

/* Align legacy rt-dialog with RtModal surface */
.rt-dialog-overlay {
  z-index: 12000 !important;
  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55)) !important;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.rt-dialog {
  border-radius: var(--radius-2xl, 16px) !important;
  box-shadow: var(--modal-shadow) !important;
  padding: 20px !important;
}

/* Identity strip under title (edit flows) */
.rt-modal-identity {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 4px;
  padding: 0 0 14px;
  border-bottom: 1px solid var(--border-subtle, var(--border));
  color: var(--text-primary);
}

.rt-modal-identity svg {
  color: var(--primary, #2563eb);
  flex-shrink: 0;
}

.rt-modal-identity__eyebrow {
  display: block;
  font-size: 11px;
  font-weight: 650;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 2px;
}

.rt-modal-identity strong {
  font-size: 0.95rem;
  font-weight: 700;
}

/* Confirm / destructive content */
.rt-modal-confirm {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
  padding: 8px 4px 4px;
}

.rt-modal-confirm__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--danger-muted, rgba(239, 68, 68, 0.12));
  color: var(--danger, #ef4444);
  font-size: 1.1rem;
}

.rt-modal-confirm__message {
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--text-primary);
  text-align: center;
  max-width: 36ch;
}

.rt-modal-confirm__entity {
  margin: 0;
  font-size: 0.9375rem;
  color: var(--text-primary);
  word-break: break-word;
}

.rt-modal-warn-banner {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid color-mix(in srgb, var(--warning, #f59e0b) 35%, transparent);
  background: var(--warning-muted, rgba(245, 158, 11, 0.12));
  color: var(--text-primary);
  font-size: 0.875rem;
  line-height: 1.45;
  text-align: left;
}

.rt-btn--danger {
  background: var(--danger, #ef4444) !important;
  border: 1px solid transparent !important;
  color: #fff !important;
}

.rt-btn--danger:hover:not(:disabled) {
  filter: brightness(0.95);
}

/* Project select (inside RtModal) */
.rt-modal--project-select {
  width: min(640px, calc(100vw - 32px));
}

.rt-project-select-list,
.workspace-modal.project-select-modal .project-select-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1 1 auto;
  min-height: 0;
  max-height: min(50vh, 360px);
  overflow-y: auto;
}

.rt-project-select-list .project-select-item,
.workspace-modal.project-select-modal .project-select-item {
  border-radius: 12px !important;
  border: 1px solid var(--border, #e2e8f0) !important;
  padding: 14px 16px !important;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.rt-project-select-list .project-select-item:hover,
.workspace-modal.project-select-modal .project-select-item:hover {
  border-color: var(--primary, #2563eb) !important;
  background: var(--primary-subtle, rgba(37, 99, 235, 0.06)) !important;
  box-shadow: var(--shadow-sm);
  transform: none !important;
}

.rt-project-select-list .project-select-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  text-align: left;
  background: var(--surface, #fff);
  color: var(--text-primary);
  cursor: pointer;
}

.workspace-modal .modal-footer {
  background: transparent !important;
}

/* Dark theme adjustments */
[data-theme='dark'] .rt-select__menu {
  background: var(--surface-elevated);
  border-color: var(--border);
}

[data-theme='dark'] .rt-select__option:hover,
[data-theme='dark'] .rt-select__option.is-active {
  background: rgba(96, 165, 250, 0.12);
}
`, "",{"version":3,"sources":["webpack://./src/styles/rt2-modal.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,uEAAuE;AACvE;;;;;;;;;;;;;;;;;EAiBE,oEAAoE;EACpE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,uEAAuE;AACvE;;;;;;;;;;;;;;EAcE,oEAAoE;EACpE,mCAAmC;EACnC,mDAAmD;EACnD,8BAA8B;EAC9B,6EAA6E;EAC7E,gBAAgB;AAClB;;AAEA,sEAAsE;AACtE;;;;;;;;;;;;;;EAcE;;;;;;gBAMc;EACd,oCAAoC;EACpC;;;;;;gBAMc;EACd,8CAA8C;EAC9C,2DAA2D;EAC3D,uCAAuC;EACvC,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;;;;;;;;;;;EAWE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,WAAW;EACX,iFAAiF;EACjF,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;;;;;;;;;EAUE,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;;;;;;EAME,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;;;;;;EAME,yBAAyB;EACzB,gDAAgD;EAChD,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;;;;;;EAME,+CAA+C;EAC/C,yBAAyB;EACzB,qCAAqC;EACrC,UAAU;AACZ;;AAEA,2DAA2D;AAC3D;;;;;;;EAOE,oCAAoC;EACpC;;;;;;gBAMc;EACd,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;;;;;;;;;EASE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;;;;;;;;;;EAUE,oDAAoD;EACpD;;;;;gBAKc;EACd,wDAAwD;AAC1D;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA,uEAAuE;AACvE;;;;;EAKE,kCAAkC;EAClC,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA,uEAAuE;AACvE;;;;;;;EAOE,gEAAgE;EAChE,uDAAuD;EACvD,6BAA6B;EAC7B,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;;;;EAIE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;;;;;;;;;EASE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,yDAAyD;EACzD,8BAA8B;EAC9B,oEAAoE;EACpE,8CAA8C;EAC9C,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;EAC1D,gBAAgB;AAClB;;AAEA;;;;;;EAME,wBAAwB;EACxB,gDAAgD;EAChD,4EAA4E;AAC9E;;AAEA;;EAEE,mDAAmD;EACnD,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EAEE,gBAAgB;EAChB,8BAA8B;EAC9B,oEAAmR;EACnR,uCAAuC;EACvC,iDAAiD;EACjD,gCAAgC;EAChC,eAAe;AACjB;;AAEA,wBAAwB;AACxB;;EAEE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;;;;EAKE;AACF;;EAEE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uEAAuE;AACvE;;;;EAIE,8CAA8C;EAC9C,wCAAwC;EACxC,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;;;EAGE,oDAAoD;EACpD,0BAA0B;AAC5B;;AAEA;;;;EAIE,2CAA2C;EAC3C,0DAA0D;EAC1D,8CAA8C;EAC9C,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;;;;EAIE,oDAAoD;AACtD;;AAEA,uEAAuE;AACvE;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kGAAkG;EAClG,yDAAyD;EACzD,0BAA0B;EAC1B,kCAAkC;EAClC,iEAAiE;AACnE;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yDAAyD;EACzD,mCAAmC;EACnC,wCAAwC;EACxC,sCAAsC;EACtC,kEAAkE;EAClE,8EAA8E;AAChF;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gDAAgD;EAChD,cAAc;EACd,yBAAyB;EACzB;;;;;;KAMG;AACL;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;;EAEE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf;iDAC+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,iEAAiE;AACnE;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yDAAyD;AAC3D;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;;EAGE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;;;;;EAME,WAAW;EACX,sBAAsB;EACtB,uCAAuC;EACvC,iBAAiB;EACjB,oDAAoD;EACpD,mBAAmB;EACnB,mDAAmD;EACnD,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sGAAsG;AACxG;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;EAIE,2CAA2C;AAC7C;;AAEA;;;;;;EAME,qCAAqC;EACrC,iEAAiE;AACnE;;AAEA;;;;;EAKE,oCAAoC;AACtC;;AAEA;;;;EAIE,4CAA4C;EAC5C,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yDAAyD;EACzD,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,qBAAqB;EACvB;;EAEA;;;;;IAKE,WAAW;IACX,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;EAC9B;AACF;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,yDAAyD;EACzD,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;;EAIE,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,oEAAoE;EACpE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,iDAAiD;EACjD,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,4DAA4D;EAC5D,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wDAAwD;EACxD,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,8EAA8E;EAC9E,0DAA0D;EAC1D,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;EAC9B,mDAAmD;EACnD,6BAA6B;EAC7B,iFAAiF;AACnF;;AAEA;;EAEE,gDAAgD;EAChD,qEAAqE;EACrE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;;EAEE,oCAAoC;AACtC","sourcesContent":["/**\n * RobiTest shared modal theme — modern white-header surface\n * Matches Edit Project / Create Test Execution (RT2).\n * Loaded via theme so it applies app-wide to [data-rt-modal-overlay] dialogs.\n */\n\n/* ── Overlay ─────────────────────────────────────────────────────── */\n[data-rt-modal-overlay].modal-overlay,\n[data-rt-modal-overlay].workspace-modal-overlay,\n[data-rt-modal-overlay].test-execution-modal-overlay,\n[data-rt-modal-overlay].create-test-suite-modal-overlay,\n[data-rt-modal-overlay].edit-test-suite-modal-overlay,\n[data-rt-modal-overlay].create-test-case-modal-overlay,\n[data-rt-modal-overlay].create-test-case-options-modal-overlay,\n[data-rt-modal-overlay].extension-recording-modal-overlay,\n[data-rt-modal-overlay].link-test-cases-modal-overlay,\n[data-rt-modal-overlay].view-test-case-modal-overlay,\n[data-rt-modal-overlay].schedule-modal-overlay,\n[data-rt-modal-overlay].rt-edit-project-overlay,\n[data-rt-modal-overlay].sprint-modal-overlay,\n.workspace-modal-overlay,\n.test-execution-modal-overlay,\n.sprint-modal-overlay,\n.rt-dialog-overlay {\n  background: var(--modal-backdrop, rgba(15, 23, 42, 0.52)) !important;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n/* ── Panel shell ─────────────────────────────────────────────────── */\n[data-rt-modal-overlay] .modal,\n[data-rt-modal-overlay] .modal-container,\n[data-rt-modal-overlay] .modal-content:not(.modal-body),\n.workspace-modal,\n.test-execution-modal,\n.create-test-suite-modal,\n.edit-test-suite-modal,\n.create-test-case-modal-panel,\n.create-test-case-options-modal-panel,\n.extension-recording-modal-panel,\n.link-test-cases-modal-panel,\n.view-test-case-modal-panel,\n.rt-edit-project-modal,\n.rt-modal {\n  background: var(--modal-background, var(--surface, #fff)) !important;\n  color: var(--text-primary, #0f172a);\n  border: 1px solid var(--border, #e2e8f0) !important;\n  border-radius: 16px !important;\n  box-shadow: var(--modal-shadow, 0 24px 48px rgba(15, 23, 42, 0.2)) !important;\n  overflow: hidden;\n}\n\n/* ── Header: highlighted primary wash (clearly not plain white) ─── */\n[data-rt-modal-overlay] .modal-header,\n.workspace-modal .modal-header,\n.test-execution-modal .modal-header,\n.create-test-suite-modal .modal-header,\n.edit-test-suite-modal .modal-header,\n.create-test-case-modal-panel .modal-header,\n.create-test-case-options-modal-header,\n.compile-scripts-modal-header,\n.rt-modal__header,\n.mfa-modal .modal-header,\n.sprint-modal .modal-header,\n.sprint-modal__header,\n.schedule-modal .modal-header,\n.link-test-suites-modal .modal-header {\n  background:\n    linear-gradient(\n      135deg,\n      rgba(37, 99, 235, 0.14) 0%,\n      rgba(59, 130, 246, 0.1) 48%,\n      rgba(96, 165, 250, 0.08) 100%\n    ) !important;\n  background-color: #eff6ff !important;\n  background-image:\n    linear-gradient(\n      135deg,\n      rgba(37, 99, 235, 0.14) 0%,\n      rgba(59, 130, 246, 0.1) 48%,\n      rgba(96, 165, 250, 0.08) 100%\n    ) !important;\n  color: var(--text-primary, #0f172a) !important;\n  border-bottom: 1px solid rgba(37, 99, 235, 0.22) !important;\n  border-radius: 16px 16px 0 0 !important;\n  padding: 18px 20px !important;\n  align-items: flex-start !important;\n  position: relative;\n  box-shadow: inset 0 -1px 0 rgba(37, 99, 235, 0.06);\n}\n\n[data-rt-modal-overlay] .modal-header::before,\n.workspace-modal .modal-header::before,\n.test-execution-modal .modal-header::before,\n.create-test-suite-modal .modal-header::before,\n.edit-test-suite-modal .modal-header::before,\n.create-test-case-modal-panel .modal-header::before,\n.rt-modal__header::before,\n.sprint-modal .modal-header::before,\n.sprint-modal__header::before,\n.schedule-modal .modal-header::before,\n.link-test-suites-modal .modal-header::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--primary, #2563eb), #60a5fa 55%, #93c5fd);\n  border-radius: 16px 16px 0 0;\n  pointer-events: none;\n}\n\n[data-rt-modal-overlay] .modal-header h2,\n[data-rt-modal-overlay] .modal-header h3,\n[data-rt-modal-overlay] .modal-header .modal-title,\n.workspace-modal .modal-header h2,\n.test-execution-modal .modal-header h2,\n.create-test-case-modal-panel .modal-header h2,\n.create-test-case-options-modal-header h2,\n.rt-modal__header h2,\n.rt-modal__title,\n.mfa-modal .modal-header h2 {\n  color: #1e3a8a !important;\n  font-size: 1.125rem !important;\n  font-weight: 700 !important;\n  letter-spacing: -0.01em;\n  margin: 0 !important;\n}\n\n[data-rt-modal-overlay] .modal-header p,\n.workspace-modal .modal-header p,\n.create-test-case-options-modal-header p,\n.rt-modal__header p,\n.rt-modal__subtitle,\n.project-select-subtitle {\n  margin: 4px 0 0 !important;\n  font-size: 0.8125rem !important;\n  font-weight: 400 !important;\n  color: #3b82f6 !important;\n  opacity: 0.9 !important;\n}\n\n.workspace-modal.project-select-modal .project-select-subtitle strong {\n  color: #1e3a8a !important;\n  font-weight: 600;\n}\n\n/* Close controls on tinted header */\n[data-rt-modal-overlay] .modal-header .modal-close,\n[data-rt-modal-overlay] .modal-header .modal-close-btn,\n[data-rt-modal-overlay] .modal-header .close-button,\n[data-rt-modal-overlay] .modal-header .close-btn,\n.workspace-modal .modal-close-btn,\n.rt-modal__close {\n  color: #3b82f6 !important;\n  background: rgba(255, 255, 255, 0.55) !important;\n  border: 1px solid rgba(37, 99, 235, 0.18);\n  border-radius: 8px;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n[data-rt-modal-overlay] .modal-header .modal-close:hover,\n[data-rt-modal-overlay] .modal-header .modal-close-btn:hover,\n[data-rt-modal-overlay] .modal-header .close-button:hover,\n[data-rt-modal-overlay] .modal-header .close-btn:hover,\n.workspace-modal .modal-close-btn:hover:not(:disabled),\n.rt-modal__close:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.9) !important;\n  color: #1d4ed8 !important;\n  border-color: rgba(37, 99, 235, 0.35);\n  opacity: 1;\n}\n\n/* Tailwind blue-gradient headers → same highlighted wash */\n[data-rt-modal-overlay] .bg-gradient-to-r.from-blue-500,\n[data-rt-modal-overlay] .bg-gradient-to-r.from-blue-600,\n[data-rt-modal-overlay] .from-blue-500.to-blue-600,\n[data-rt-modal-overlay] .from-blue-600.to-blue-700,\n[data-rt-modal-overlay] .from-blue-500.to-indigo-600,\n[data-rt-modal-overlay] .from-blue-600.to-indigo-700,\n[data-rt-modal-overlay] .from-blue-600.to-blue-500 {\n  background-color: #eff6ff !important;\n  background-image:\n    linear-gradient(\n      135deg,\n      rgba(37, 99, 235, 0.14) 0%,\n      rgba(59, 130, 246, 0.1) 48%,\n      rgba(96, 165, 250, 0.08) 100%\n    ) !important;\n  color: #1e3a8a !important;\n  border-bottom: 1px solid rgba(37, 99, 235, 0.22);\n}\n\n[data-rt-modal-overlay] .bg-gradient-to-r.from-blue-500 h2,\n[data-rt-modal-overlay] .bg-gradient-to-r.from-blue-600 h2,\n[data-rt-modal-overlay] .from-blue-500.to-blue-600 h2,\n[data-rt-modal-overlay] .from-blue-600.to-blue-700 h2,\n[data-rt-modal-overlay] .from-blue-500.to-indigo-600 h2,\n[data-rt-modal-overlay] .bg-gradient-to-r .text-white,\n[data-rt-modal-overlay] .bg-gradient-to-r h2.text-white,\n[data-rt-modal-overlay] .bg-gradient-to-r .text-xl,\n[data-rt-modal-overlay] .bg-gradient-to-r .text-lg {\n  color: #1e3a8a !important;\n}\n\n[data-rt-modal-overlay] .bg-gradient-to-r p,\n[data-rt-modal-overlay] .bg-gradient-to-r .text-blue-100,\n[data-rt-modal-overlay] .bg-gradient-to-r .opacity-80,\n[data-rt-modal-overlay] .bg-gradient-to-r .text-xs {\n  color: #3b82f6 !important;\n  opacity: 0.9 !important;\n}\n\n[data-rt-modal-overlay] .bg-gradient-to-r button,\n[data-rt-modal-overlay] .bg-gradient-to-r .hover\\:bg-white\\/20 {\n  color: #3b82f6 !important;\n}\n\n[data-rt-modal-overlay] .bg-gradient-to-r button:hover {\n  background: rgba(255, 255, 255, 0.9) !important;\n  color: #1d4ed8 !important;\n}\n\n[data-theme='dark'] [data-rt-modal-overlay] .modal-header,\n[data-theme='dark'] .workspace-modal .modal-header,\n[data-theme='dark'] .test-execution-modal .modal-header,\n[data-theme='dark'] .rt-modal__header,\n[data-theme='dark'] .create-test-case-modal-panel .modal-header,\n[data-theme='dark'] .create-test-case-options-modal-header,\n[data-theme='dark'] .compile-scripts-modal-header,\n[data-theme='dark'] .mfa-modal .modal-header,\n[data-theme='dark'] .sprint-modal .modal-header,\n[data-theme='dark'] .schedule-modal .modal-header {\n  background-color: rgba(37, 99, 235, 0.18) !important;\n  background-image:\n    linear-gradient(\n      135deg,\n      rgba(59, 130, 246, 0.22) 0%,\n      rgba(37, 99, 235, 0.12) 100%\n    ) !important;\n  border-bottom-color: rgba(96, 165, 250, 0.28) !important;\n}\n\n[data-theme='dark'] [data-rt-modal-overlay] .modal-header h2,\n[data-theme='dark'] .rt-modal__header h2,\n[data-theme='dark'] .rt-modal__title,\n[data-theme='dark'] .workspace-modal .modal-header h2 {\n  color: #bfdbfe !important;\n}\n\n[data-theme='dark'] [data-rt-modal-overlay] .modal-header p,\n[data-theme='dark'] .rt-modal__header p,\n[data-theme='dark'] .rt-modal__subtitle {\n  color: #93c5fd !important;\n}\n\n[data-theme='dark'] .rt-modal__close,\n[data-theme='dark'] [data-rt-modal-overlay] .modal-header .modal-close,\n[data-theme='dark'] [data-rt-modal-overlay] .modal-header .close-btn {\n  color: #93c5fd !important;\n  background: rgba(15, 23, 42, 0.35) !important;\n  border-color: rgba(147, 197, 253, 0.25);\n}\n\n/* ── Body ────────────────────────────────────────────────────────── */\n[data-rt-modal-overlay] .modal-body,\n[data-rt-modal-overlay] .modal-content,\n.workspace-modal .modal-body,\n.test-execution-modal .modal-content,\n.rt-modal__body {\n  background: transparent !important;\n  color: var(--text-primary);\n  padding: 20px !important;\n}\n\n/* ── Footer ──────────────────────────────────────────────────────── */\n[data-rt-modal-overlay] .modal-footer,\n[data-rt-modal-overlay] .modal-actions,\n.workspace-modal .modal-footer,\n.test-execution-modal .modal-footer,\n.create-test-case-modal-panel .modal-footer,\n.compile-scripts-modal-footer,\n.rt-modal__footer {\n  background: var(--bg-secondary, var(--surface, #fff)) !important;\n  border-top: 1px solid var(--border, #e2e8f0) !important;\n  padding: 14px 20px !important;\n  gap: 10px !important;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n/* ── Form fields inside modals ───────────────────────────────────── */\n[data-rt-modal-overlay] .form-group label,\n[data-rt-modal-overlay] label.form-label,\n.workspace-modal .form-group label,\n.test-execution-modal .form-group > label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 0.8125rem;\n  font-weight: 550;\n  color: var(--text-secondary, #475569);\n}\n\n[data-rt-modal-overlay] input:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='file']):not([type='hidden']),\n[data-rt-modal-overlay] textarea,\n[data-rt-modal-overlay] select:not([multiple]),\n[data-rt-modal-overlay] .form-input,\n[data-rt-modal-overlay] .form-control,\n.workspace-modal .form-input,\n.test-execution-modal input,\n.test-execution-modal textarea,\n.test-execution-modal select {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 12px;\n  border: 1px solid var(--input-border, #e2e8f0) !important;\n  border-radius: 10px !important;\n  background: var(--input-background, var(--surface, #fff)) !important;\n  color: var(--text-primary, #0f172a) !important;\n  font-family: inherit;\n  font-size: 0.875rem;\n  line-height: 1.4;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-shadow: none;\n}\n\n[data-rt-modal-overlay] input:not([type='checkbox']):not([type='radio']):focus,\n[data-rt-modal-overlay] textarea:focus,\n[data-rt-modal-overlay] select:focus,\n[data-rt-modal-overlay] .form-input:focus,\n[data-rt-modal-overlay] .form-control:focus,\n.workspace-modal .form-input:focus {\n  outline: none !important;\n  border-color: var(--primary, #2563eb) !important;\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(37, 99, 235, 0.2)) !important;\n}\n\n[data-rt-modal-overlay] input::placeholder,\n[data-rt-modal-overlay] textarea::placeholder {\n  color: var(--input-placeholder, #94a3b8) !important;\n  opacity: 1;\n}\n\n/* Native select chevron */\n[data-rt-modal-overlay] select:not([multiple]) {\n  -webkit-appearance: none;\n  appearance: none;\n  padding-right: 36px !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748B' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\") !important;\n  background-repeat: no-repeat !important;\n  background-position: right 12px center !important;\n  background-size: 16px !important;\n  cursor: pointer;\n}\n\n/* Checkboxes & radios */\n[data-rt-modal-overlay] input[type='checkbox'],\n[data-rt-modal-overlay] input[type='radio'] {\n  width: 1.05rem !important;\n  height: 1.05rem !important;\n  min-width: 1.05rem;\n  margin: 0;\n  accent-color: var(--primary, #2563eb);\n  cursor: pointer;\n  flex-shrink: 0;\n  vertical-align: middle;\n}\n\n[data-rt-modal-overlay] .checkbox-label,\n[data-rt-modal-overlay] label:has(> input[type='checkbox']),\n[data-rt-modal-overlay] label:has(> input[type='radio']) {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  color: var(--text-primary);\n}\n\n/*\n * AccessibleSelect / rt-select visuals for modals only.\n * Do NOT set global .rt-select { width: 100% } — that breaks FilterBar\n * toolbars (Test Cases, Projects, etc.) into stacked full-width rows.\n * Canonical select layout lives in components/ui/ui.css.\n */\n[data-rt-modal-overlay] .rt-select--form,\n[data-rt-modal-overlay] .rt-select:not(.rt-select--filter):not(.rt-select--sm) {\n  width: 100%;\n}\n\n[data-rt-modal-overlay] .rt-select__trigger {\n  border-radius: 10px;\n}\n\n[data-rt-modal-overlay] .rt-select__menu {\n  border-radius: 12px;\n  z-index: 20000;\n}\n\n/* ── Primary / secondary buttons in modals ───────────────────────── */\n[data-rt-modal-overlay] .modal-action-btn,\n[data-rt-modal-overlay] .btn-primary,\n.workspace-modal .btn-primary,\n.test-execution-modal .btn-primary {\n  background: var(--primary, #2563eb) !important;\n  border: 1px solid transparent !important;\n  color: #fff !important;\n  border-radius: 10px !important;\n  font-weight: 600;\n  padding: 0.55rem 1.1rem;\n  box-shadow: none !important;\n  background-image: none !important;\n}\n\n[data-rt-modal-overlay] .modal-action-btn:hover:not(:disabled),\n[data-rt-modal-overlay] .btn-primary:hover:not(:disabled),\n.workspace-modal .btn-primary:hover:not(:disabled) {\n  background: var(--primary-hover, #1d4ed8) !important;\n  transform: none !important;\n}\n\n[data-rt-modal-overlay] .modal-cancel-btn,\n[data-rt-modal-overlay] .btn-secondary,\n[data-rt-modal-overlay] .btn-outline,\n.workspace-modal .btn-outline {\n  background: var(--surface, #fff) !important;\n  border: 1px solid var(--border-strong, #cbd5e1) !important;\n  color: var(--text-primary, #0f172a) !important;\n  border-radius: 10px !important;\n  font-weight: 550;\n  padding: 0.55rem 1.1rem;\n  background-image: none !important;\n  box-shadow: none !important;\n}\n\n[data-rt-modal-overlay] .modal-cancel-btn:hover:not(:disabled),\n[data-rt-modal-overlay] .btn-secondary:hover:not(:disabled),\n[data-rt-modal-overlay] .btn-outline:hover:not(:disabled),\n.workspace-modal .btn-outline:hover:not(:disabled) {\n  background: var(--surface-hover, #f8fafc) !important;\n}\n\n/* ── Shared RtModal shell ────────────────────────────────────────── */\n.rt-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 12000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: max(12px, env(safe-area-inset-top, 0px)) 16px max(12px, env(safe-area-inset-bottom, 0px));\n  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55));\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  animation: rt-modal-overlay-in var(--duration-normal, 200ms) ease;\n}\n\n.rt-modal {\n  width: min(520px, calc(100vw - 32px));\n  max-height: min(88vh, 720px);\n  max-height: min(88dvh, 720px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--modal-background, var(--surface, #fff));\n  color: var(--text-primary, #0f172a);\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: var(--radius-2xl, 16px);\n  box-shadow: var(--modal-shadow, 0 24px 48px rgba(15, 23, 42, 0.2));\n  animation: rt-modal-panel-in var(--duration-slow, 320ms) var(--ease-out, ease);\n}\n\n.rt-modal--sm {\n  width: min(420px, calc(100vw - 32px));\n  max-height: min(80vh, 560px);\n  max-height: min(80dvh, 560px);\n}\n\n.rt-modal--md {\n  width: min(520px, calc(100vw - 32px));\n}\n\n.rt-modal--lg {\n  width: min(720px, calc(100vw - 32px));\n  max-height: min(90vh, 820px);\n  max-height: min(90dvh, 820px);\n}\n\n.rt-modal--xl {\n  width: min(960px, calc(100vw - 32px));\n  max-height: min(92vh, 900px);\n  max-height: min(92dvh, 900px);\n}\n\n.rt-modal--confirm,\n.rt-modal--destructive {\n  width: min(440px, calc(100vw - 32px));\n}\n\n.rt-modal__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 18px 20px 16px;\n  border-bottom: 1px solid rgba(37, 99, 235, 0.22);\n  flex-shrink: 0;\n  background-color: #eff6ff;\n  background-image:\n    linear-gradient(\n      135deg,\n      rgba(37, 99, 235, 0.14) 0%,\n      rgba(59, 130, 246, 0.1) 48%,\n      rgba(96, 165, 250, 0.08) 100%\n    );\n}\n\n.rt-modal__header-text {\n  min-width: 0;\n  flex: 1;\n}\n\n.rt-modal__title,\n.rt-modal__header h2 {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 700;\n  letter-spacing: -0.015em;\n  line-height: 1.3;\n  color: #1e3a8a;\n}\n\n.rt-modal__subtitle,\n.rt-modal__header p {\n  margin: 4px 0 0;\n  font-size: 0.8125rem;\n  line-height: 1.45;\n  color: #3b82f6;\n}\n\n.rt-modal__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  border: 1px solid rgba(37, 99, 235, 0.18);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.55);\n  color: #3b82f6;\n  cursor: pointer;\n  transition: background var(--duration-fast, 120ms) ease, color var(--duration-fast, 120ms) ease,\n    border-color var(--duration-fast, 120ms) ease;\n}\n\n.rt-modal__close:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.95);\n  color: #1d4ed8;\n  border-color: rgba(37, 99, 235, 0.35);\n}\n\n.rt-modal__close:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(37, 99, 235, 0.2));\n}\n\n.rt-modal__close:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.rt-modal__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  scrollbar-gutter: stable;\n  -webkit-overflow-scrolling: touch;\n}\n\n.rt-modal--confirm .rt-modal__body,\n.rt-modal--destructive .rt-modal__body {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.rt-modal__section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.rt-modal__section + .rt-modal__section {\n  margin-top: 4px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-subtle, var(--border));\n}\n\n.rt-modal__section-title {\n  margin: 0 0 2px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.rt-modal__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 0;\n}\n\n.rt-modal__label,\n.rt-modal__field > span,\n.rt-modal__field > label {\n  font-size: 0.8125rem;\n  font-weight: 550;\n  color: var(--text-secondary);\n}\n\n.rt-modal__req {\n  color: var(--danger, #ef4444);\n  font-weight: 600;\n}\n\n.rt-modal__field input,\n.rt-modal__field textarea,\n.rt-modal__field select,\n.rt-modal__body input:not([type='checkbox']):not([type='radio']):not([type='file']):not([type='hidden']),\n.rt-modal__body textarea,\n.rt-modal__body select:not([multiple]) {\n  width: 100%;\n  box-sizing: border-box;\n  min-height: var(--control-height, 36px);\n  padding: 8px 12px;\n  border: 1px solid var(--input-border, var(--border));\n  border-radius: 10px;\n  background: var(--input-background, var(--surface));\n  color: var(--text-primary);\n  font-family: inherit;\n  font-size: 0.875rem;\n  line-height: 1.4;\n  box-shadow: none;\n  outline: none;\n  transition: border-color var(--duration-fast, 120ms) ease, box-shadow var(--duration-fast, 120ms) ease;\n}\n\n.rt-modal__field textarea,\n.rt-modal__body textarea {\n  min-height: 88px;\n  resize: vertical;\n}\n\n.rt-modal__field input:hover:not(:disabled),\n.rt-modal__field textarea:hover:not(:disabled),\n.rt-modal__body input:hover:not(:disabled):not([type='checkbox']):not([type='radio']),\n.rt-modal__body textarea:hover:not(:disabled) {\n  border-color: var(--border-strong, #cbd5e1);\n}\n\n.rt-modal__field input:focus,\n.rt-modal__field textarea:focus,\n.rt-modal__field select:focus,\n.rt-modal__body input:focus,\n.rt-modal__body textarea:focus,\n.rt-modal__body select:focus {\n  border-color: var(--primary, #2563eb);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(37, 99, 235, 0.2));\n}\n\n.rt-modal__field input.error,\n.rt-modal__field textarea.error,\n.rt-modal__body input.error,\n.rt-modal__body textarea.error,\n.rt-modal__body select.error {\n  border-color: var(--danger, #ef4444);\n}\n\n.rt-modal__field input:disabled,\n.rt-modal__field textarea:disabled,\n.rt-modal__body input:disabled,\n.rt-modal__body textarea:disabled {\n  background: var(--surface-disabled, #f1f5f9);\n  color: var(--text-muted);\n  cursor: not-allowed;\n}\n\n.rt-modal__grid-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n.rt-modal__grid-3 {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.rt-modal-meta {\n  margin-top: 4px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border-subtle, var(--border));\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n}\n\n.rt-modal-meta p {\n  margin: 0 0 4px;\n}\n\n.rt-modal-meta p:last-child {\n  margin-bottom: 0;\n}\n\n@media (max-width: 640px) {\n  .rt-modal__grid-3 {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 560px) {\n  .rt-modal__grid-2 {\n    grid-template-columns: 1fr;\n  }\n\n  .rt-modal-overlay {\n    padding: 8px;\n    align-items: flex-end;\n  }\n\n  .rt-modal,\n  .rt-modal--sm,\n  .rt-modal--md,\n  .rt-modal--lg,\n  .rt-modal--xl {\n    width: 100%;\n    max-height: min(92vh, 100%);\n    max-height: min(92dvh, 100%);\n    border-radius: 16px 16px 0 0;\n  }\n}\n\n.rt-modal__hint {\n  margin: 0;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.rt-modal__error,\n.rt-modal__body .error-message {\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--danger, #ef4444);\n}\n\n.rt-modal__footer,\n.rt-modal__actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 14px 20px;\n  border-top: 1px solid var(--border-subtle, var(--border));\n  background: transparent;\n  flex-shrink: 0;\n}\n\n.rt-modal__footer .rt-btn,\n.rt-modal__actions .rt-btn,\n.rt-modal__footer .btn,\n.rt-modal__actions .btn {\n  min-height: var(--control-height, 36px);\n  border-radius: 10px;\n  font-weight: 600;\n  padding: 0 14px;\n}\n\n@keyframes rt-modal-overlay-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes rt-modal-panel-in {\n  from { opacity: 0; transform: translateY(8px) scale(0.985); }\n  to { opacity: 1; transform: none; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .rt-modal-overlay,\n  .rt-modal {\n    animation: none !important;\n  }\n}\n\n/* Align legacy rt-dialog with RtModal surface */\n.rt-dialog-overlay {\n  z-index: 12000 !important;\n  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55)) !important;\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n.rt-dialog {\n  border-radius: var(--radius-2xl, 16px) !important;\n  box-shadow: var(--modal-shadow) !important;\n  padding: 20px !important;\n}\n\n/* Identity strip under title (edit flows) */\n.rt-modal-identity {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0 0 4px;\n  padding: 0 0 14px;\n  border-bottom: 1px solid var(--border-subtle, var(--border));\n  color: var(--text-primary);\n}\n\n.rt-modal-identity svg {\n  color: var(--primary, #2563eb);\n  flex-shrink: 0;\n}\n\n.rt-modal-identity__eyebrow {\n  display: block;\n  font-size: 11px;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin-bottom: 2px;\n}\n\n.rt-modal-identity strong {\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n/* Confirm / destructive content */\n.rt-modal-confirm {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  text-align: center;\n  padding: 8px 4px 4px;\n}\n\n.rt-modal-confirm__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: var(--danger-muted, rgba(239, 68, 68, 0.12));\n  color: var(--danger, #ef4444);\n  font-size: 1.1rem;\n}\n\n.rt-modal-confirm__message {\n  margin: 0;\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--text-primary);\n  text-align: center;\n  max-width: 36ch;\n}\n\n.rt-modal-confirm__entity {\n  margin: 0;\n  font-size: 0.9375rem;\n  color: var(--text-primary);\n  word-break: break-word;\n}\n\n.rt-modal-warn-banner {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 1px solid color-mix(in srgb, var(--warning, #f59e0b) 35%, transparent);\n  background: var(--warning-muted, rgba(245, 158, 11, 0.12));\n  color: var(--text-primary);\n  font-size: 0.875rem;\n  line-height: 1.45;\n  text-align: left;\n}\n\n.rt-btn--danger {\n  background: var(--danger, #ef4444) !important;\n  border: 1px solid transparent !important;\n  color: #fff !important;\n}\n\n.rt-btn--danger:hover:not(:disabled) {\n  filter: brightness(0.95);\n}\n\n/* Project select (inside RtModal) */\n.rt-modal--project-select {\n  width: min(640px, calc(100vw - 32px));\n}\n\n.rt-project-select-list,\n.workspace-modal.project-select-modal .project-select-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: min(50vh, 360px);\n  overflow-y: auto;\n}\n\n.rt-project-select-list .project-select-item,\n.workspace-modal.project-select-modal .project-select-item {\n  border-radius: 12px !important;\n  border: 1px solid var(--border, #e2e8f0) !important;\n  padding: 14px 16px !important;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.rt-project-select-list .project-select-item:hover,\n.workspace-modal.project-select-modal .project-select-item:hover {\n  border-color: var(--primary, #2563eb) !important;\n  background: var(--primary-subtle, rgba(37, 99, 235, 0.06)) !important;\n  box-shadow: var(--shadow-sm);\n  transform: none !important;\n}\n\n.rt-project-select-list .project-select-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  width: 100%;\n  text-align: left;\n  background: var(--surface, #fff);\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.workspace-modal .modal-footer {\n  background: transparent !important;\n}\n\n/* Dark theme adjustments */\n[data-theme='dark'] .rt-select__menu {\n  background: var(--surface-elevated);\n  border-color: var(--border);\n}\n\n[data-theme='dark'] .rt-select__option:hover,\n[data-theme='dark'] .rt-select__option.is-active {\n  background: rgba(96, 165, 250, 0.12);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
